import { THEME_IDS } from '@accedo/vdkweb-ui/lib/components/Menu';
import * as menu from './menu.scss';

export default {
  [THEME_IDS.Menu]: menu,
  [THEME_IDS.MenuItem]: menu
};
